import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { SharedRoutes } from '@pgaoc/shared-lib';
import { MemberAuthRepository } from '../repository/member-auth-repository';

type Activation = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private memberAuthRepository = inject(MemberAuthRepository);
  private router = inject(Router);

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    next: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): Activation {
    return this.memberAuthRepository.isAuthenticated().pipe(
      take(1),
      map(authenticatedUser => {
        return !!authenticatedUser || this.router.createUrlTree([SharedRoutes.auth()]);
      }),
    );
  }
}
